import wretch from "wretch";
import Wretch from "./Wretch.mjs";
import ResponseChunk from "./ResponseChunk.mjs";

import Log from "../../utils/Log.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import UtilNumber from "@/utils/UtilNumber";

// console.log(process);

class ERP{

    constructor(){};

    // await ERP.getOneById("schema","id");
    async getOneById(schema,id){

        return await Wretch.get("/Entity/:schema/:id", {
            pathParams:{
                schema: schema,
                id: id
            }
        });

    }

    // await ERP.getManyById("schema","ids");
    async getManyById(schema,ids=[]){

        return await Wretch.get("/Entity/:schema/search-fields",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                ids: ids.toString(),
                limit: 999,
            }
        });

    }

    // await ERP.getOneByValue("schema","search","value");
    async getOneByValue(schema,search,value){

        return await Wretch.get("/Entity/:schema/search-fields",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                searchFields: search,
                value: value,
                limit: 1,
                mode: "Equals",
            }
        });

    }

    // await ERP.getOneByValue("schema","search","value");
    async getManyByValue(schema,search,value){

        return await Wretch.get("/Entity/:schema/search-fields",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                searchFields: search,
                value: value,
                limit: 999,
                mode: "Equals",
            }
        });

    }

    // await ERP.getNextSequence({
    //     "parentSchema",
    //     "parentID",
    //     "relationSchema",
    //     "relationField",
    //     "sequenceField"
    // });
    async getNextSequence(payload){

        let response = {
            data: {
                parentSchema: payload.parentSchema,
                parentID: payload.parentID,
                relationSchema: payload.relationSchema,
                relationField: payload.relationField,
                sequenceField: payload.sequenceField,
                sequenceFill: payload.sequenceFill,
                value: null,
            },
            status: 200,
        };

        try{

            //==================================================================//
            //=================== Pega o Parent Response =======================//
            //==================================================================//

            let parentResponse = await this.getOneById(payload.parentSchema,payload.parentID);
            if(parentResponse.status != 200){
                throw parentResponse;
            }

            //==================================================================//
            //===================== Pega o Relation IDs ========================//
            //================== Se Vazio assume Sequencia 1 ===================//
            //==================================================================//

            let relationIDs = parentResponse.data[payload.relationField] || [];

            if(UtilArray.isEmpty(relationIDs)){

                response.data.value = UtilNumber.formatSequence({
                    valor: 1,
                    preencher: payload.sequenceFill,
                });

                return response;
            }

            //==================================================================//
            //===================== Pega o Relation IDs ========================//
            //==================================================================//

            let relationResponse = await this.getManyById(payload.relationSchema, relationIDs);
            if(relationResponse.status != 200){
                throw relationResponse;
            }

            //==================================================================//
            //===================== Pega a Maior Sequencia =====================//
            //==================================================================//
            
            const maxSequence = relationResponse.data.reduce((max,relationItem)=>{

                const value = UtilNumber.toNumber(relationItem[payload.sequenceField]);

                return value > max ? value : max;

            },0);

            response.data.value = maxSequence + 1;

            //==================================================================//
            //======================== Format Sequence =========================//
            //==================================================================//

            response.data.value = UtilNumber.formatSequence({
                valor: response.data.value,
                preencher: payload.sequenceFill,
            });

        }catch(e){

            console.log(e);
            response.status = 500;
            return response;

        }

        return response;

    }


    // await ERP.postOne("schema",{
    //    key: "value"
    // });
    async postOne(schema,params){

        return await Wretch.post("/Entity/insertMany/:schema",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                limit: 1,
            },
            body:[params]
        });

    }

    // await ERP.postMany("schema",[
    //     {
    //         key: "value"
    //     },
    // ]);
    async postMany(schema = "", data = [], options = {} ){

        if(UtilArray.isEmpty(data)){
            Log.error(`PostMany de ${schema} não pode ser vazio.`);
        }

        options = {
            chunkSize: 500,
            barra: false,
            ...options
        }

        let chunks = UtilArray.chunk(data,options.chunkSize);

        let responses = [];
        for await (let chunk of chunks) {

            let response = await Wretch.post("/Entity/insertMany/:schema",{
                pathParams:{
                    schema:schema
                },
                queryParams:{
                    limit: 500,
                },
                body:chunk
            });

            responses.push(response);

        }

        let treatedResponse = ResponseChunk.treat(responses);

        return treatedResponse;

    }

    // await ERP.putOne("schema",{
    //    id: "value"
    //    key: "value"
    // });
    async putOne(schema,params){

        return await Wretch.put("/Entity/updateMany/:schema",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                limit: 1,
            },
            body:[params]
        });

    }

    // await ERP.postMany("schema",[
    //     {
    //         id: "value"
    //         key: "value"
    //     },
    // ]);
    async putMany(schema,params){

        return await Wretch.put("/Entity/updateMany/:schema",{
            pathParams:{
                schema:schema
            },
            queryParams:{
                limit: 999,
            },
            body:params
        });

    }



    // await ERP.patchOne("schema",{
    //     id: "value"
    //     key: "value"
    // });
    async patchOne(schema,payload){

        let response;

        try{

            response = await this.getOneById(schema, payload.id);
            if(response.status != 200){
                throw response;
            }

            payload = {
                ...response.data,
                ...payload,
            };

            response = await this.putOne(schema,payload);
            if(response.status != 200){
                throw response;
            }

        }catch(e){

            console.log(e);
            return response;

        }

        return response;

    }



    // await ERP.patchMany("schema",[
    //     {
    //         id: "value"
    //         key: "value"
    //     },
    // ]);
    async patchMany(schema,payload){

        let response;

        try{

            let payloadIDs = payload.map(({id}) => id);

            response = await this.getManyById(schema, payloadIDs);
            if(response.status != 200){
                throw response;
            }

            payload = response.data.map((responseItem)=>{

                let payloadItem = payload.find(({id})=> id == responseItem.id);

                return{
                    ...responseItem,
                    ...payloadItem
                }

            });

            response = await this.putMany(schema,payload);
            if(response.status != 200){
                throw response;
            }

        }catch(e){

            console.log(e);
            return response;

        }

        return response;

    }


    // await ERP.getOneWithView("viewName",[
    //     {
    //         name: "key",
    //         dataType: "String",
    //         value: "value"
    //     },
    //     {
    //         name: "key",
    //         dataType: "String",
    //         value: "value"
    //     },
    // ]);
    async getOneWithView(view,params=[]){

        /*
            O View/run utiliza um Dictonary para desconstruir e interpretar os campos do outro lado, portanto deve-se enviar no objeto sempre nessa ordem:
            - params
            - viewName
            - page
            - limit
        */
        return await Wretch.post("/View/run",{
            queryParams:{
                limit: 1,
            },
            body:{
                params: params,
                viewName: view,
                page: 1,
                limit: 100000000
            }
        })

    }

    // await ERP.getManyWithView("viewName",[
    //     {
    //         name: "key",
    //         dataType: "String",
    //         value: "value"
    //     },
    //     {
    //         name: "key",
    //         dataType: "String",
    //         value: "value"
    //     },
    // ]);
    async getManyWithView(view,params=[]){

        /*
            O View/run utiliza um Dictonary para desconstruir e interpretar os campos do outro lado, portanto deve-se enviar no objeto sempre nessa ordem:
            - params
            - viewName
            - page
            - limit
        */
        return await Wretch.post("/View/run",{
            queryParams:{
                limit: 100000000,
            },
            body:{
                params: params,
                viewName: view,
                page: 1,
                limit: 100000000
            }
        })

    }

    // await ERP.sendGridEmail({
    //     destinatarioNome: "String",
    //     destinatarioEmail: "String",
    //     assunto: "String",
    //     comCopia: [ "String", "String" ],
    //     conteudo: "String",
    //     anexos: [
    //         {
    //             fileName: "String",
    //             file:"StringBase64"
    //         }
    //     ]
    // });
    async sendGridEmail(params){

        return await Wretch.post("/UserAccess/SendEmail",{
            queryParams:{
                limit: 1,
            },
            body:{
                nameTo: params?.destinatarioNome || "",
                to: params?.destinatarioEmail || "",
                subject: params?.assunto || "",
                copyTo: params?.comCopia || [],
                copyToHidden: params?.comCopiaOculta || [],
                files: params?.anexos || [],
                plainTextContent: "Dummy",
                htmlContent: params?.conteudo || ""
            }
        })

    }

    // await ERP.createREM({
    //     pagamentoEletronico: "Object",
    // });
    async createREM(params){

        // Não utiliza a API do ERP para realizar a Requisição, o que torna esse recurso Exposto.
        // Isso a meu ver é uma falha de segurança, seria bom criar um createREM do lado do ERP.
    
        return wretch("https://cnab.deltaducon.com.br")
            .options({ mode: "cors", cache:"default" })
            .content("application/json")
            .resolve(resolver => resolver
                .badRequest(async (error)=>{

                    return {
                        url: error.url,
                        status: error.status,
                        statusText: error.response.statusText,
                        message: "Falha ao Gerar o Arquivo REM",
                        data: error.json
                    }

                })
                .res( async (success) => {

                    let data = await success.json();

                    return {
                        url: success.url,
                        status: success.status,
                        statusText: success.statusText,
                        data: data
                    }

                })
            )
            .url("/itau/cnab240/remessa")
            .post(params.remDados)

    }

    // await ERP.sendGridEmail({
    //     destinatarioNome: "String",
    //     destinatarioEmail: "String",
    //     assunto: "String",
    //     comCopia: [ "String", "String" ],
    //     conteudo: "String",
    //     anexos: [
    //         {
    //             fileName: "String",
    //             file:"StringBase64"
    //         }
    //     ]
    // });
    async getNotaFiscalByPlugNotasId(params){

        const badResponse = async (error) => {

            return {
                url: error?.response?.url,
                status: error?.response?.status,
                statusText: error?.response?.statusText,
                message: error?.json?.error?.message,
                data: {}
            }

        }

        const goodResponse = async (response) => {

            const blob = await response.blob();

            return{
                url: response?.url,
                status: response?.status,
                statusText: response?.statusText,
                message: "Nota Fiscal obtida com sucesso",
                data: blob
            }
        }

        /*
            ACCIST (Depreciado, Próxima vez que mexer deletar):

            Homologação (Não usamos mais).
            https://api.sandbox.plugnotas.com.br
            '2da392a6-79d2-4304-a8b7-959572c7e44d'

            Produção (Não usamos mais).
            'https://api.plugnotas.com.br
            21c94f51-ca20-4ba0-a6d2-ffc23291680c

        */

        /*
            ZYON:

            Homologação
            https://api.sandbox.plugnotas.com.br
            '5bbf2aa2efee08a50be2cefaf8ab8811'

            Produção
            https://api.plugnotas.com.br
            '5bbf2aa2efee08a50be2cefaf8ab8811'
        */

        return wretch("https://api.plugnotas.com.br")
            .options({ mode: "cors", cache:"default" })
            .headers({"X-API-KEY": "5bbf2aa2efee08a50be2cefaf8ab8811"})
            .resolve( resolver => resolver
                .badRequest(async (error) => await badResponse(error))
                .unauthorized(async (error) => await badResponse(error))
                .forbidden(async (error) => await badResponse(error))
                .notFound(async (error) => await badResponse(error))
                .timeout(async (error) => await badResponse(error))
                .internalError( async (error) => await badResponse(error))
                .error(418, async  (error) => await badResponse(error))
                .fetchError( async (error) => await badResponse(error))
                .res(async  (response) => await goodResponse(response))
            )
            .url(`/nfe/${params.plugNotasId}/pdf`)
            .get()
    
    }

}

const SingletonERP = new ERP();
export default SingletonERP;